import { combineReducers } from 'redux';
import performance from './performance';
import salesFilters from './salesFilters';
import managerSales from './managerSales';
import associateScorecard from './associateScorecard';
import associateEngagements from './associateEngagements';
import expandedScorecard from './expandedScorecard';
import reminders from './reminders';
import divisionsPerDesigner from './divisionsPerDesigner';
import groupsPerDesigner from './groupsPerDesigner';
import associateSales from './associateSales';
import clientConnects from './clientConnects';

const appReducer = combineReducers({
  performance,
  salesFilters,
  managerSales,
  associateScorecard,
  associateEngagements,
  reminders,
  expandedScorecard,
  divisionsPerDesigner,
  groupsPerDesigner,
  associateSales,
  clientConnects,
});

export default (state, action) => appReducer(state, action);
